import React from 'react';

import {
  Text,
  IconError,
  IconWarning,
  IconNotSend,
  IconAccepted,
  IconOptional,
  WrapperContentTable,
} from './styles';

const ConteudoPorStatus = ({
  idLista,
  idArquivo,
  statusDocumento,
  handleModalDetalheDocumento,
  beneficiario,
  tipoDocumento,
}) => {
  const ContentStatus = {
    EmValidacao: {
      Icon: <IconWarning />,
      Text: (
        <Text cursorPointer={idArquivo !== 0}>
          Pendente de <wbr /> validação
        </Text>
      ),
    },
    Aceito: {
      Icon: <IconAccepted />,
      Text: (
        <Text marginRight="64px" cursorPointer={idArquivo !== 0}>
          Aceito
        </Text>
      ),
    },
    Recusado: {
      Icon: <IconError />,
      Text: (
        <Text marginRight="46px" cursorPointer={idArquivo !== 0}>
          Recusado
        </Text>
      ),
    },
    NaoEnviado: {
      Icon: <IconNotSend />,
      Text: (
        <Text marginRight="29px" cursorPointer={idArquivo !== 0}>
          Não Enviado
        </Text>
      ),
    },
    EnvioOpcional: {
      Icon: <IconOptional />,
      Text: (
        <Text marginRight="15px" cursorPointer={idArquivo !== 0}>
          Envio Opcional
        </Text>
      ),
    },
    'Envio Obrigatório': {
      Icon: <IconNotSend />,
      Text: (
        <Text marginRight="29px" cursorPointer={idArquivo !== 0}>
          Não Enviado
        </Text>
      ),
    },
    'Envio Opcional': {
      Icon: <IconOptional />,
      Text: (
        <Text marginRight="29px" cursorPointer={idArquivo !== 0}>
          Envio Opcional
        </Text>
      ),
    },
    Aprovado: {
      Icon: <IconAccepted />,
      Text: (
        <Text marginRight="64px" cursorPointer={idArquivo !== 0}>
          Aceito
        </Text>
      ),
    },
    Reprovado: {
      Icon: <IconError />,
      Text: (
        <Text marginRight="46px" cursorPointer={idArquivo !== 0}>
          Recusado
        </Text>
      ),
    },
  };

  function handleIconPorStatus() {
    return ContentStatus[statusDocumento].Icon;
  }
  function handleTextPorStatus() {
    return ContentStatus[statusDocumento].Text;
  }

  return (
    <WrapperContentTable
      width={statusDocumento === 'EmValidacao' ? '159px' : '131px'}
      data-tip={idArquivo === 0 ? 'não há documento' : 'ver documento'}
      onClick={
        idArquivo === 0
          ? null
          : () =>
              handleModalDetalheDocumento(
                idArquivo,
                idLista,
                beneficiario.id,
                beneficiario?.idMovimentacao,
                tipoDocumento,
                statusDocumento
              )
      }
    >
      {handleIconPorStatus()}
      {handleTextPorStatus()}
    </WrapperContentTable>
  );
};

export default ConteudoPorStatus;
